import React from 'react'

const PrivacyPolicy = () => {
    return (
        <>
            <div className='terms-page fraunces' id='Privacy-Policy'>
                {/* banner */}
                <div className='banner' >
                    <div className='container-fluid bgimg'>
                        <h1>Privacy Policy</h1>
                    </div>
                </div>
                {/* text-desc*/}
                <div id='text-desc' className='side-spacing'>
                    <div className='container-fluid'>
                        <p className='text-desc'>At Chawla & Associates, CPAs, your privacy matters. As a professional accounting firm based in Naperville, Illinois, we understand that your financial, business, and personal data isn’t just confidential—it’s foundational to your trust in us. This Privacy Policy explains how we collect, use, share, and protect your information—online and offline—when you interact with our firm through our website, client portals, email, and other channels.
                            <br></br>    <br></br>
                            By accessing our website or engaging with our firm, you agree to the terms below.
                        </p>
                    </div>
                </div>
                {/* Scope of This Policy */}
                <div id='Scope-of-This-Policy' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'> Scope of This Policy
                        </h1>
                        <p className='text-desc'>
                            This policy applies to:
                            <ul className='check-list'>
                                <li>Visitors of our website <a href='/' target='_blank'>https://chawlacpa.com/</a> </li>
                                <li>Clients and prospective clients of Chawla & Associates, CPAs </li>
                                <li>Users who contact us via online forms, email, or phone</li>
                                <li>Any information shared through secure client portals, online document uploads, or scheduling tools we use</li>
                            </ul>
                            This policy does not apply to third-party websites you may access through links on our site. Their policies will govern your interaction with them.
                        </p>
                    </div>
                </div>
                {/* Information We Collect */}
                <div id='Information-We-Collect' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>Information We Collect
                        </h1>
                        <p className='text-desc top'>
                            We collect both personally identifiable information (“Personal Information”) and non-identifiable information in several ways:
                            <ul className='check-list'>
                                <li>Information You Provide Voluntarily:
                                    <ul className='dot'>
                                        <li><b>Contact Details:</b> Name, phone number, email address, mailing address</li>
                                        <li><b>Client Intake Data:</b>  Business name, EIN, tax ID, income information, expense reports, accounting records, payroll info, and other financial or legal documents</li>
                                        <li><b>Communication Records:</b> Emails, inquiries submitted through forms, messages exchanged via client portals</li>
                                        <li><b>Billing Information:</b> Payment details for services rendered</li>
                                    </ul>
                                </li>
                                <li>Information We Collect Automatically:
                                    <p className='text-desc'>When you visit our website, we may collect:</p>
                                    <ul className='dot'>
                                        <li>IP address and general geolocation</li>
                                        <li>Browser type and device data</li>
                                        <li>Pages viewed and time spent on our website</li>
                                        <li>Referral links, if applicable </li>
                                        <li>Cookies and tracking data (see Section 6)</li>
                                    </ul>
                                </li>
                            </ul>
                            <p className='text-desc'>We do not knowingly collect data from children under 13. If such data is inadvertently collected, it will be promptly deleted.</p>
                        </p>
                    </div>
                </div>
                {/* How We Use Your Information */}
                <div id='How-We-Use-Your-Information' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>How We Use Your Information
                        </h1>
                        <p className='text-desc top'>
                            We use your information to:
                            <ul className='check-list'>
                                <li>Deliver professional accounting, tax, and advisory services</li>
                                <li>Respond to inquiries and manage client relationships</li>
                                <li>Process payments and manage billing</li>
                                <li>Set up and manage secure client portal access</li>
                                <li>Send important updates or regulatory notifications</li>
                                <li>Improve the usability, security, and performance of our website</li>
                                <li>Comply with applicable tax laws, professional standards, and regulatory obligations</li>
                            </ul>
                            We may also use aggregate, non-identifiable data for internal analysis and service optimization.
                        </p>
                    </div>
                </div>
                {/* Legal Basis for Processing (for users in applicable jurisdictions) */}
                <div id='Legal-Basis-for-Processing' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>Legal Basis for Processing (for users in applicable jurisdictions)
                        </h1>
                        <p className='text-desc top'>
                            Depending on your location, we process your personal information under lawful bases such as:
                            <ul className='check-list'>
                                <li><strong>Performance of a contract</strong> (e.g., providing accounting services)s</li>
                                <li><strong>Legal obligations</strong> (e.g., tax compliance, audits)</li>
                                <li><strong>Legitimate interests</strong> (e.g., client relationship management)</li>
                                <li><strong>Your consent</strong> (e.g., marketing emails, if opted-in)</li>
                            </ul>
                        </p>
                    </div>
                </div>
                {/* How We Share Information */}
                <div id='How-We-Share-Information' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                            How We Share Information
                        </h1>
                        <p className='text-desc top'>
                            We value your privacy and never sell your personal information. We may share information only under limited, controlled circumstances:
                            <ul className='check-list'>
                                <li><strong>With Trusted Service Providers:</strong> For hosting, IT support, scheduling, email delivery, or secure cloud storage—all under confidentiality agreements.</li>
                                <li><strong>With Government Agencies or Regulators:</strong> If required by law, court order, or professional obligations (e.g., IRS, Illinois Department of Revenue).</li>
                                <li><strong>Within the Firm:</strong> Among staff, partners, and authorized contractors to provide services efficiently and securely.</li>
                                <li><strong>In Business Transactions:</strong> If our firm is involved in a merger, acquisition, or asset sale, client information may be transferred, with safeguards in place.</li>
                            </ul>
                        </p>
                    </div>
                </div>
                {/* Cookies and Analytics */}
                <div id='Cookies-and-Analytics' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                            Cookies and Analytics
                        </h1>
                        <p className='text-desc top'>
                            We use cookies and similar technologies to improve user experience and analyze website traffic. This may include:
                            <ul className='check-list'>
                                <li>Session cookies (for site navigation)</li>
                                <li>Google Analytics or similar tools (for usage metrics)</li>
                                <li>Third-party scripts (e.g., scheduling or chat tools)</li>
                            </ul>
                            You can disable cookies through your browser settings, but doing so may limit functionality.
                            <br></br>
                            We do not use cookies to track you across other websites, and we do not engage in behavioral advertising.
                        </p>
                    </div>
                </div>
                {/* Data Security and Storage */}
                <div id='Cookies-and-Analytics' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                            Data Security and Storage
                        </h1>
                        <p className='text-desc top'>
                            We implement industry-standard safeguards to protect your information:
                            <ul className='check-list'>
                                <li>Secure servers and encryption protocols (SSL/TLS)</li>
                                <li>Multi-factor authentication (MFA) on client portals</li>
                                <li>Firewalls, access controls, and role-based permissions</li>
                                <li>Routine data backups and system monitoring</li>
                            </ul>
                            We retain client records only as long as necessary for the purpose collected, legal retention periods, or contractual obligations. When data is no longer needed, we securely dispose of or anonymize it.
                        </p>
                    </div>
                </div>
                {/* Your Privacy Rights */}
                <div id='Your-Privacy-Rights' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                             Your Privacy Rights
                        </h1>
                        <p className='text-desc top'>
                            Depending on your location, you may have certain rights, including:
                            <ul className='check-list'>
                                <li>The right to access, correct, or delete your personal information</li>
                                <li>The right to object to or restrict certain data uses</li>
                                <li>The right to withdraw consent at any time (where applicable)</li>
                                <li>The right to receive your data in a structured, portable format</li>
                            </ul>
                            To exercise your rights, email us at <a href='mailto:info@chawlacpa.com'>info@chawlacpa.com</a>. We may need to verify your identity before processing your request.
                        </p>
                    </div>
                </div>
                {/* Marketing Communications */}
                <div id='Marketing-Communications' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                            Marketing Communications
                        </h1>
                        <p className='text-desc top'>
                            We may send occasional updates about tax deadlines, regulatory changes, or firm news. You’ll only receive these communications if you’ve opted in.
                            <br></br><br></br>
                            You can unsubscribe at any time by clicking the link in the email or contacting us directly. We do not spam.
                        </p>
                    </div>
                </div>
                {/* Data Transfers */}
                <div id='Data-Transfers' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                            Data Transfers
                        </h1>
                        <p className='text-desc top'>
                            Our firm is based in the United States. If you are accessing our services from outside the U.S., you understand that your information may be transferred to—and stored in—U.S. systems.
                            <br></br><br></br>
                            We take all necessary precautions to ensure that international data transfers comply with applicable laws.
                        </p>
                    </div>
                </div>
                {/* Policy-Updates */}
                <div id='Policy-Updates' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>
                             Policy Updates
                        </h1>
                        <p className='text-desc top'>
                            We may revise this Privacy Policy periodically. If changes are significant, we’ll provide clear notice either on the Site or via direct communication.
                            <br></br><br></br>
                            The “Last Updated” date at the top of the policy reflects the most recent changes. Continued use of our Site after revisions means you accept the updated terms.
                        </p>
                    </div>
                </div>
                   {/* Contact Us */}
                   <div id='Contact-Us' className='side-spacing'>
                    <div className='container-fluid'>
                        <h1 className='main-head'>Contact Us</h1>
                        <p className='text-desc'>
                            If you have any questions about these Terms, please contact us:
                            <span className='strong'>Chawla & Associates, CPAs</span>
                            <span><a href='https://maps.app.goo.gl/WkdzCASCZKaSpNo67' target='_blank'>2752 Forgue Dr Suite 100-B,<br></br>
                                Naperville, IL 60564</a>
                            </span>
                            <span>Phone: <a href='tel:+1 630-922-8600'>+1 630-922-8600</a></span>
                            <span>Email: <a href='mailto:info@chawlacpa.com '>info@chawlacpa.com </a></span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy
